import type { PointWithdrawalType } from "@roman/shared/types/PointWithdrawal";
import Banner1 from "./img/gift_banner_1.png";
import Banner2 from "./img/gift_banner_2.png";

type Props = {
  onClickCard: (cardId: PointWithdrawalType) => void;
};

const body = [
  {
    id: "AuPay",
    giftTitle: "えらべるPay",
    banner: Banner1,
    text: "500円分 - 100,000円分",
  },
  {
    id: "Giftee",
    giftTitle: "giftee Box Select",
    banner: Banner2,
    text: "500円分 - 100,000円分",
  },
];

export const GiftTickets = ({ onClickCard }: Props) => {
  return (
    <div>
      <div className="flex flex-col items-start gap-3">
        <div className="flex items-center">
          <p className="text-xl font-bold text-black">選べるギフト券</p>
        </div>
        <div className="flex flex-row gap-3">
          {body.map((item, index) => (
            <div
              key={index}
              className="w-1/2 sm:w-[180px] bg-white cursor-pointer"
              onClick={() => onClickCard(item.id as PointWithdrawalType)}
            >
              <div className="text-sm font-bold text-dark-gray -tracking-[.01em] mb-1">{item.giftTitle}</div>
              <div className="rounded-md border border-[#01A4F9] bg-[#01A4F9] overflow-hidden">
                <div className="bg-white">
                  <img src={item.banner} alt="" width="100%" />
                </div>
                <div className="text-center p-3">
                  <p className="text-white font-bold text-xs leading-tight">{item.giftTitle}</p>
                  <p className="text-white font-semibold text-xs">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
